import HTTP_ERP from '@/config/axios-config-erp'

const ServiceComprasVentas = {
  getComprasVentas(payload) {
    return HTTP_ERP.post(`/wscomun/portalinformes/getComprasVentas`, payload).then(respuesta => {
      return respuesta
    }).catch(error => {
      return error
    })
  }
}

export default ServiceComprasVentas



// WEBPACK FOOTER //
// ./src/services/srv-compras-ventas.js